document.addEventListener('DOMContentLoaded', () => {
  // 1. DOM references and configuration
  const controlsSelector = '.template_product_description_price_control';
  const btnSelector = '.pdp-qty__btn';
  const inputSelector = '.pdp-qty__input';

  // 2. Main logic: calculate and clamp the next quantity value
  const getNumber = (value, fallback) => {
    const num = parseInt(value, 10);
    return Number.isFinite(num) ? num : fallback;
  };

  const clamp = (value, min, max) => {
    if (value < min) return min;
    if (max !== null && value > max) return max;
    return value;
  };

  const getBounds = (input) => {
    const min = getNumber(input.min, 1); // Default to 1 if min is missing/invalid
    const step = getNumber(input.step, 1);
    const max = input.max ? getNumber(input.max, null) : null;

    return { min, max, step };
  };

  const setQuantity = (input, nextValue) => {
    input.value = nextValue;
    // Important for Dawn/Shopify: trigger change so other scripts stay in sync
    input.dispatchEvent(new Event('change', { bubbles: true })); // WE CURRENTLY DONT HAVE BUBBLES
  };

  // 3. Event handlers
  const handleQtyButtonClick = (event) => {
    const btn = event.target.closest(btnSelector);
    if (!btn) return;

    const wrapper = btn.closest(controlsSelector);
    if (!wrapper) return;

    const input = wrapper.querySelector(inputSelector);
    if (!input) return;

    const action = btn.dataset.action; // "increase" | "decrease"
    const { min, max, step } = getBounds(input);

    const currentValue = getNumber(input.value, min);

    const delta = action === 'increase' ? step : action === 'decrease' ? -step : 0;
    if (delta === 0) return;

    const nextValue = clamp(currentValue + delta, min, max);
    setQuantity(input, nextValue);
  };

  const handleQtyInputChange = (event) => {
    const input = event.target;
    if (!input.classList.contains('pdp-qty__input')) return;

    // Enforce min >= 1 when user types manually
    const { min, max } = getBounds(input);
    const currentValue = getNumber(input.value, min);
    const nextValue = clamp(currentValue, min, max);

    if (nextValue !== currentValue) {
      setQuantity(input, nextValue);
    }
  };

  // 4. Bind event listeners (event delegation = works with dynamic DOM updates)
  document.addEventListener('click', handleQtyButtonClick);
  document.addEventListener('change', handleQtyInputChange);
});